// Which mode the location page opens in. The share sheet's "Standort" and
// "Treffpunkt" tiles both open the conversation's location dialog (its
// showLocationDialog() takes no arguments), so the tile leaves the requested mode
// here and ChatShareMap takes it when it mounts. An `initialMode` prop on
// ChatShareMap wins over it.
let pendingMode = null;

export function requestLocationMode(mode) {
  pendingMode = mode === "meeting" ? "meeting" : "location";
}

export function takeLocationMode() {
  const mode = pendingMode;
  pendingMode = null;
  return mode;
}

/** The message format the mobile app sends and parses (MessageComponent.sendMapMessage). */
export function buildMapMessage(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return "";
  const round = (n) => String(Math.round(n * 1e7) / 1e7);
  const a = round(la);
  const b = round(ln);
  return `http://www.google.com/maps/place/${a},${b}/@${a},${b},17z`;
}
